import React, { Component } from 'react';
import { Tabs, Spin } from 'antd';
import { connect } from 'react-redux';
import AfficheNews from './afficheNews';
import ProjectIndicatorAnalysis from './projectIndicatorAnalysis';
import FinanceIndicatorAnalysis from './FinanceIndicatorAnalysis';
import Statement from './statement';
import PerformanceRank from './performanceRank';
import RequestDataAnalysis from '../RequestDataAnalysis';
import PersonIndicatorAnalysis from './personIndicatorAnalysis';
import MyFocus from './myFocus';
import MonthlyPlan from './monthlyPlan';
import API_URL from '../../common/url';
import Fetch from '../../common/Fetch';
import dictCache from '../../common/dictCache';
import { queryApprovalUserCachedAsync } from '../../common/permissionCache';
import format from '../shared/format';
import { saveParams } from '../../actions/noticeActions';
import './style.less';
import fp from '../../utils/fp';

const { TabPane } = Tabs;

class HomePage extends Component {
    constructor(props) {
        super(props);
        const { location: { state } = {}, match } = props || {};
        this.state = {
            auth: {},
            panes: [],
            activeKey: state ? state.key : (match ? match.params.pageType : ''),
            loading: false,
            business: [],
            contractType: [],
            systemDate: {},
            additionalMenuList: [],
            isSeniorUserBo: false,
            FINANCE_INDICATOR_ANALYSIS: false,
            isDesignatedTal: false,
            isLineCharge: false,
        };
    }

    componentDidMount() {
        this.checkLogin();
        this.queryAuth();
        this.queryBusiness();
        this.queryConfigure();
        this.querySystemDate();
        this.queryArea();
        this.queryApprovalUser();
        window.addEventListener('switchToMonthlyPlan', this.handleSwitchToMonthlyPlan);
    }

    componentWillUnmount() {
        window.removeEventListener('switchToMonthlyPlan', this.handleSwitchToMonthlyPlan);
    }

    handleSwitchToMonthlyPlan = () => {
        this.setState({ activeKey: 'monthlyPlan' });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.auth !== this.state.auth
            || prevState.isSeniorUserBo !== this.state.isSeniorUserBo
            || prevState.FINANCE_INDICATOR_ANALYSIS !== this.state.FINANCE_INDICATOR_ANALYSIS
            || prevState.isDesignatedTal !== this.state.isDesignatedTal
            || prevState.isLineCharge !== this.state.isLineCharge) {
            this.updatePanes();
        }
    }

    queryApprovalUser = () => {
        queryApprovalUserCachedAsync()
            .then(res => {
                const { additionalMenuList = [], isSeniorUserBo = false, FINANCE_INDICATOR_ANALYSIS = false, isDesignatedTal = false, isLineCharge = false } = res;
                this.setState({
                    additionalMenuList,
                    isSeniorUserBo,
                    FINANCE_INDICATOR_ANALYSIS,
                    isDesignatedTal,
                    isLineCharge,
                });
        })
    }

    checkLogin = () => {
        Fetch.post(API_URL.config.getRedirectUrl)
            .then(res => {
                const { redirectUrl } = res;
                if(!!redirectUrl) location.href = redirectUrl;
        })
    }

    queryAuth = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.requestDataAnalysis.queryRemittanceReportRoleAuthorityByRoleCode)
            .then(res => {
                this.setState({
                    auth: res || {},
                    loading: false,
                });
            })
            .catch(err => console.error(err));
    }

    queryBusiness = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, { typeName: 'LINE_OF_BUSINESS' })
                .then(cb);
        }, res => {
            const business = res.typeConfigureList.slice();
            business.unshift({ typeValue: '所有项目', typeConfigureId: -1 });
            this.setState({ business });
        });
    }

    queryConfigure = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList)
                .then(cb);
        }, res => {
            const contractType = res.contractTypeList.slice();
            contractType.unshift({ typeValue: '所有合同', typeConfigureId: -1 });
            this.setState({ contractType });
        });
    }

    querySystemDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            Fetch.post(API_URL.home.queryEffectiveDate)
                .then(cb);
        }, res => {
            this.setState({ systemDate: { ...res, monthDate: format('month', res.date) } });
        });
    }

    queryArea = () => {
        dictCache.getDict('AREA_ALL', cb => {
            Fetch.post(API_URL.common.queryAllInvestigationArea)
                .then(cb)
                .catch(error => {
                    console.error(error);
                });
        }, res => this.setState({ area: res.data }));
    }

    updatePanes = () => {
        const { auth, activeKey, additionalMenuList, isSeniorUserBo, FINANCE_INDICATOR_ANALYSIS, isDesignatedTal, isLineCharge } = this.state;
        const { curRole , userName } = sessionStorage;
        const isAdditionalUser = additionalMenuList.some(el => el.menuKey === 'REPORT_QUERY'); //是否为后台配置新增的可以查看报表查询人员
        console.log(isAdditionalUser);
        const panes = [{
            title: '公告动态',
            key: 'afficheNews',
            component: AfficheNews,
        }];
        // 年度/月度计划 - 仅临床部成员可见（组件内部已做权限校验）
        panes.push({
            title: '年度/月度计划',
            key: 'monthlyPlan',
            component: MonthlyPlan,
        });
        if (auth.projectIndicatorAnalysis) {
            panes.push({
                title: '项目指标分析',
                key: 'projectIndicator',
                component: ProjectIndicatorAnalysis,
            });
        }
        
        if (fp.contains(curRole)(['VP', 'BO', 'FIN', 'CRCC', 'CRCM', 'PML', 'HRRC']) ) {
            panes.push({
                title: '人员指标分析',
                key: 'personIndicator',
                component: PersonIndicatorAnalysis,
            });
        }
        if (curRole === 'FIN' || isSeniorUserBo || FINANCE_INDICATOR_ANALYSIS || isDesignatedTal || isLineCharge) {
            panes.push({
                title: '财务指标分析',
                key: 'financeIndicator',
                component: FinanceIndicatorAnalysis,
            });
        }
        if (curRole == 'VP' || curRole == 'BO' || curRole == 'FIN' || curRole == 'PML' || curRole == 'HRRC' || auth.reportForms || isAdditionalUser) {
            panes.push({
                title: '报表查询',
                key: 'statement',
                component: Statement,
            });
        }

        panes.push(
        // ,
        // {
        //     title: '人员指标分析',
        //     key: 'userIndicator',
        //     disabled: true,
        //     content: null,
        // }, 
        {
            title: '绩效排行',
            key: 'performanceRank',
            component: PerformanceRank,
        });
        //暂时放开权限
        panes.push({
            title: '我的关注',
            key: 'myFocus',
            component: MyFocus,
        });
        if (auth.requestDataAnalysis) {
            panes.push({
                title: '请款数据分析',
                key: 'requestDataAnalysis',
                component: RequestDataAnalysis,
            });
        }

        this.setState({
            panes,
            activeKey: activeKey || 'afficheNews',
        });
    }

    getContent = ({ key, component: Content }) => {
        const { auth, activeKey, business, contractType, systemDate, area, additionalMenuList } = this.state;
        if (activeKey === key) {
            const settings = {};
            if (activeKey === 'requestDataAnalysis') {
                settings.auth = auth.requestDataAnalysis;
            } else if (activeKey === 'projectIndicator' || activeKey === 'financeIndicator'  || activeKey === 'personIndicator') {
                settings.area = area;
                settings.business = business;
                settings.contractType = contractType;
                settings.systemDate = systemDate;
                settings.financeIndicatorAnalysis = auth.financeIndicatorAnalysis;
                settings.projectIndicatorAnalysis = auth.projectIndicatorAnalysis;
                settings.isSeniorUserBo = this.state.isSeniorUserBo;
                settings.FINANCE_INDICATOR_ANALYSIS = this.state.FINANCE_INDICATOR_ANALYSIS;
                settings.isDesignatedTal = this.state.isDesignatedTal;
                settings.isLineCharge = this.state.isLineCharge;
            } else if (activeKey === 'statement') {
                settings.additionalMenuList = additionalMenuList;
            }
            return (
                <Content {...settings} />
            );
        } else {
            return null;
        }
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    render() {
        const { panes, activeKey, loading } = this.state;
        const cancelMarginBottom = activeKey === 'requestDataAnalysis' ? ' m-b-0' : '';
        return (
            <Spin spinning={loading}>
                <div className={`homePage${cancelMarginBottom}`}>
                    <Tabs activeKey={activeKey} onChange={this.handleTabsChange}>
                        {panes.map(pane => <TabPane tab={pane.title} key={pane.key} disabled={pane.disabled}>{this.getContent(pane)}</TabPane>)}
                    </Tabs>
                </div>
            </Spin>
        );
    }
}
const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/homePage/index.js